/** @format */

import { io } from 'socket.io-client';
import { store } from '../redux/store';

export const socket = io(process.env.REACT_APP_SOCKET_URL, {
  path: '', //? This is the path that the server is listening on
  autoConnect: false,
  port: process.env.REACT_APP_SOCKET_PORT,
});

socket.on('connect', async () => {
  console.log('Connected to socket.io server');
  const currentUser = await store.getState().user.currentUser;

  if (currentUser && socket.connected) {
    socket.emit('UserToID', {
      userAuth: currentUser,
      socketID: socket.id,
    });
  }
});

// socket.on('test', (data) => {
// console.log(data.message);
// });
